export default {
    validate(value, args) {
        const date = new Date(value)
        const maxDate = new Date(args.maxDate)
        return date < maxDate
    },
    params: ['maxDate']
}
